import { useRef } from 'react';
import { CSVLink } from 'react-csv';

const AnalyticsExportButton = ({ headers, data, filename, loading }) => {
	const linkRef = useRef();
	const disabled = loading || !data || data.length === 0 || !headers || headers.length === 0;

	const handleClick = () => {
		if (disabled) return;
		if (linkRef.current && linkRef.current.link) {
			linkRef.current.link.click();
		}
	};

	return (
		<>
			<button
				type="button"
				onClick={handleClick}
				disabled={disabled}
				aria-label="Export to Excel"
				title="Export to Excel"
				style={{
					background: 'transparent',
					border: 'none',
					padding: '0.25rem',
					display: 'inline-flex',
					alignItems: 'center',
					justifyContent: 'center',
					cursor: disabled ? 'not-allowed' : 'pointer',
					opacity: disabled ? 0.4 : 1,
					color: 'inherit',
				}}
			>
				<span className="material-symbols-outlined" style={{ fontSize: 18, lineHeight: 1 }}>file_export</span>
			</button>
			<CSVLink
				ref={linkRef}
				headers={headers || []}
				data={data || []}
				filename={filename || 'export.csv'}
				style={{ display: 'none' }}
				target="_self"
			/>
		</>
	);
};

export default AnalyticsExportButton;
